"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscribeOption = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _reactHookForm = require("react-hook-form");
var _hooks = require("../../../hooks");
var _context = require("../context");
var _types = require("../types");
var _Cashback = require("./Cashback");
var _SelectDeliveryFrequency = require("./SelectDeliveryFrequency");
var _SubscribeBenefits = require("./SubscribeBenefits");
var _SubscribeOptionLabel = require("./SubscribeOptionLabel");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SubscribeOption = ({
  showDeliveryFrequencySelect = true
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    subscribeOptionCashback
  } = (0, _context.useSubscriptionModule)();
  const {
    control,
    formState: {
      disabled
    }
  } = (0, _reactHookForm.useFormContext)();
  const mode = (0, _reactHookForm.useWatch)({
    name: 'mode',
    control
  });
  const checked = mode === _types.SubscriptionModuleMode.Subscribe;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.SUBSCRIBE_OPTION),
    checked: !disabled && checked,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CashbackWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Cashback.Cashback, {
        cashback: subscribeOptionCashback
      }), subscribeOptionCashback ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "caption",
        color: "text.secondary",
        children: translations.subscribeCashbackDescription
      }) : null]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormControlLabel, {
      "data-testid": getTestId(_constants.SUBSCRIBE_OPTION_RADIO),
      value: _types.SubscriptionModuleMode.Subscribe,
      control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Radio, {
        disabled: disabled
      }),
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscribeOptionLabel.SubscribeOptionLabel, {})
    }), checked && !disabled ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscribeBenefits.SubscribeBenefits, {}), showDeliveryFrequencySelect ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectDeliveryFrequency.SelectDeliveryFrequency, {}) : null]
    }) : null]
  });
};
exports.SubscribeOption = SubscribeOption;
//# sourceMappingURL=SubscribeOption.js.map